import { render, staticRenderFns } from "./TeacherReportDetail.vue?vue&type=template&id=3c530e00&scoped=true&"
import script from "./TeacherReportDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherReportDetail.vue?vue&type=style&index=0&id=3c530e00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c530e00",
  null
  
)

export default component.exports